import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import { Navigate } from 'react-router-dom';
import moment from "moment";
import {
  TextInput,
} from "components/Input/Index.js";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";
import DateInput from "components/Input/DateInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { membercontracts } from "variables/markets";
import { membercontractStatusDataSelect, membercontractStatusDataSelectNoAdmin } from "variables/lists/markets";
import { postMarketMembershipFile, getMarketMemberships, getFiles } from "services/ConfigServices";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import { MarketsContext } from "context/MarketsContext";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import Chip from "@mui/material/Chip";
import LocalizationAutocomplete from "components/LocalizationAutocomplete/LocalizationAutocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function CreateContractDialog(props) {
  const { closeModal, refetch } = props;
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const markets_admin = permis.includes("markets_admin");
  const markets_update = permis.includes("markets_update");

  const appContext = useContext(MarketsContext);
  const { market } = appContext;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = advancedSearchContext;

  const [membershipsOptions, setMembershipsOptions] = useState([]);
  const [memberships, setMemberships] = useState([]);
  const [membership, setMembership] = useState("");
  const [membershipGroup, setMembershipGroup] = useState("");

  const [marketmembershipid, setMarketmembershipid] = useState("");
  const [docnumber, setDocnumber] = useState("");
  const [docname, setDocname] = useState("");
  const [legalentity, setLegalentity] = useState("");
  const [representedby, setRepresentedby] = useState("");
  const [datebegin, setDatebegin] = useState("");
  const [dateend, setDateend] = useState("");
  const [datesignature, setDatesignature] = useState("");
  const [status, setStatus] = useState("");
  const [associatedfiles, setAssociatedfiles] = useState("");

  const [groups, setGroups] = useState("");
  const [groupsParent, setGroupsParent] = useState(
    market?.parameters?.general?.groups?.[0]
  );

  const [buttonDisabled, setButtonDisabled] = useState(true);

  useEffect(() => {
    if (
      docnumber.length > 0 &&
      docname.length > 0 &&
      datebegin &&
      dateend &&
      membership
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [docnumber, docname, datebegin, dateend, membership]);


  const handleSubmit = async (event) => {
    createMandate(event);
  };

  const handleMarketmembershipidChange = (event) => { setMarketmembershipid(event.target.value); };
  const handleDocnumberChange = (event) => { setDocnumber(event.target.value); };
  const handleDocnameChange = (event) => { setDocname(event.target.value); };
  const handleLegalentityChange = (event) => { setLegalentity(event.target.value); };
  const handleRepresentedbyChange = (event) => { setRepresentedby(event.target.value); };
  const handleDatebeginChange = (event) => { setDatebegin(event.target.value); };
  const handleDateendChange = (event) => { setDateend(event.target.value); };
  const handleDatesignatureChange = (event) => { setDatesignature(event.target.value); };
  const handleStatusChange = (event) => { setStatus(event.target.value); };

  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  useEffect(() => {
    if (membershipGroup) {
      axios
        .get(getFiles(membershipGroup), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          setGedList(res.data.collection || []);
        });
    }
  }, [membershipGroup]);

  const handleMembershipChange = (newValue) => {
    setMembership(newValue);
    if (newValue) {
      let obj = memberships.find((o) => o.id === newValue.id);
      setMembershipGroup(obj?.parameters.groups[0]);
      setLegalentity(obj?.parameters.company || "");
      setRepresentedby(obj?.parameters.contactname || "");
      setAssociatedfiles("");
    }
    else {
      setMembershipGroup("");
    }
  };

  const selectedMembership = () => {
    let selected = {};
    if (membership !== undefined) {
      selected = membership;
    }
    return selected;
  };

  useEffect(() => {
    axios
      .get(
        getMarketMemberships(chartIdGroup, market.id),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        let tmpMembershipsData = res.data.memberships?.map((data) => {
          return (
            { name: data.parameters.name + ' (' + data.parameters.marketmembershipnumber + ')', id: data.id }
          );
        });
        setMembershipsOptions(tmpMembershipsData || []);
        setMemberships(res.data.memberships || []);
      });

  }, []);

  const selectedDocuments = () => {
    let selected = {};
    if (associatedfiles !== undefined) {
      selected = associatedfiles;
    }
    return selected;
  };
  const handleAssociatedfilesChange = (newValue) => {
    setAssociatedfiles(newValue);
  };

  const createMandate = async (event) => {
    await axios
      .post(
        postMarketMembershipFile(membership.id, 'membercontract'),
        {
          docnumber,
          docname,
          legalentity,
          representedby,
          datebegin,
          dateend,
          datesignature,
          status,
          associatedfiles,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Contrat créé");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <AutocompleteInputMeters
                isRequired
                specialWidth={"97%"}
                inputTitle={"Choix de l'adhérent"}
                selected={selectedMembership()}
                list={membershipsOptions}
                handleChange={(_, newValue) =>
                  handleMembershipChange(newValue)
                }
              />
            </div>
            {membership &&
              <>
                <div>
                  <TextInput
                    isRequired
                    inputTitle={membercontracts.docnumber}
                    textInput={docnumber}
                    handleTextInputChange={handleDocnumberChange}
                  />
                </div>
                <div>
                  <TextInput
                    isRequired
                    inputTitle={membercontracts.docname}
                    textInput={docname}
                    handleTextInputChange={handleDocnameChange}
                  />
                </div>
                <div>
                  <TextInput
                    inputTitle={membercontracts.legalentity}
                    textInput={legalentity}
                    handleTextInputChange={handleLegalentityChange}
                  />
                </div>
                <div>
                  <TextInput
                    inputTitle={membercontracts.representedby}
                    textInput={representedby}
                    handleTextInputChange={handleRepresentedbyChange}
                  />
                </div>
                <div>
                  <DateInput
                    isRequired
                    inputTitle={membercontracts.datebegin}
                    dateInput={datebegin}
                    handleDateInputChange={handleDatebeginChange}
                  />
                </div>
                <div>
                  <DateInput
                    isRequired
                    inputTitle={membercontracts.dateend}
                    dateInput={dateend}
                    handleDateInputChange={handleDateendChange}
                  />
                </div>
                <div>
                  <DateInput
                    inputTitle={membercontracts.datesignature}
                    dateInput={datesignature}
                    handleDateInputChange={handleDatesignatureChange}
                  />
                </div>
                <div>
                  <CustomSelect
                    inputTitle={membercontracts.status}
                    selectValue={status}
                    handleSelectValueChange={handleStatusChange}
                    data={markets_admin ? membercontractStatusDataSelect : membercontractStatusDataSelectNoAdmin}
                  />
                </div>
                <div>
                  <AutocompleteInput
                    isMultiple={false}
                    specialWidth={"97%"}
                    inputTitle={membercontracts.associatedfiles}
                    selected={selectedDocuments()}
                    list={gedList}
                    handleChange={(_, newValue) =>
                      handleAssociatedfilesChange(newValue)
                    }
                    renderTags={(tagValue, getTagProps) =>
                      tagValue.map((option, index) => (
                        <Chip label={option.title} {...getTagProps({ index })} />
                      ))
                    }
                  />
                </div>
              </>
            }

            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Créer
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </>
  );
}

export default CreateContractDialog;
